export const UserStatus = {
    SIGN_IN: "signIn",
    SIGN_UP: "signUp",
    LOG_OUT: "logOut",
    USER_REGISTER: "user_register"
  };

export const userSignIn = user => ({
  type: UserStatus.SIGN_IN,
  user
});

export const userLogOut = () => ({
  type: UserStatus.LOG_OUT
});

